import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import { ControlLabel, Glyphicon } from "react-bootstrap";
import { INPUT_TYPE } from "../../../config/constants";

import translator from "../../../components/localization/translator";

class FormInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
        }
    }

    renderInput() {
        let className = this.props.inputStyle || "";
        const errorMessage = this.props.getErrorMessage() || "";
        const input = (
            <input
                type={this.props.type}
                name={this.props.name}
                required={this.props.required}
                id={this.props.id}
                placeholder={translator.translate(this.props.placeholder || "")}
                autoComplete={this.props.name}
                value={this.state.value || ""}
                validations={this.props.validations}
                disabled={this.props.disabled || false}
                onChange={(e) => {
                    const value = e.target.value;
                    this.setState({ value });
                    if ("function" === typeof this.props.onChange) {
                        this.props.onChange(e);
                    }
                }}
                className={`form-control default-font ${className}`}
                onBlur={this.props.onBlur} />
        );
        return (
            <React.Fragment>
                {this.props.showPasswordToggle ? (
                    <div className="display-flex align-center form-input-password-toggle-wrap">
                        <div className="form-input-password-toggle-input">
                            {input}
                        </div>
                        <button
                            type="button"
                            className="btn btn-link form-input-password-toggle-btn"
                            tabIndex={-1}
                            title={this.props.passwordVisible ? "Hide password" : "Show password"}
                            aria-label={this.props.passwordVisible ? "Hide password" : "Show password"}
                            onClick={(e) => {
                                e.preventDefault();
                                if (typeof this.props.onTogglePasswordVisibility === "function") {
                                    this.props.onTogglePasswordVisibility();
                                }
                            }}>
                            <Glyphicon glyph={this.props.passwordVisible ? "eye-close" : "eye-open"} />
                        </button>
                    </div>
                ) : input}
                <div
                    className={"validation-error distance-field default-font red-color"}>{translator.translate(errorMessage)}</div>
            </React.Fragment>
        );
    }

    render() {
        let additionalStyle = this.props.style ? "padding" : "";
        if (this.props.inputType === INPUT_TYPE.GRID) {
            return (
                <div className={`display-flex align-center ${additionalStyle} ${this.props.formContainerStyle || ""}`}>
                    {this.props.label ? <label htmlFor={this.props.htmlFor}
                                               className={"label-width"}>{translator.translate(this.props.label)}</label> : null}
                    <div
                        className={`${this.props.label ? "my-custom-input" : ""} ${this.props.inputContainerStyle || ""}`}
                        style={{ width: "-webkit-fill-available" }}>
                        {this.renderInput()}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="margin-bottom distance-field">
                    <ControlLabel htmlFor={this.props.id}>{translator.translate(this.props.label)}</ControlLabel>
                    {this.renderInput()}
                </div>
            );
        }
    }
}

FormInput.defaultProps = {
    inputType: INPUT_TYPE.GRID,
};
export default withFormsy(FormInput);
